import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { FRAGMENT_CO_CAMPAIGN } from 'src/graphql/continuousOptimization';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProject, BackendQueryProjectArgs } from 'src/types/backend';

const QUERY = gql`
  query ProjectOptimizationData($projectId: Int!) {
    project(id: $projectId) {
      id

      # "last used asset type" detection
      generationRequests(first: 1) {
        edges {
          node {
            ... on RecomposeRequest {
              assetType
              language
              briefTitle
              briefBody
              emailPromotion
            }
            ... on SuggestionRequest {
              assetType
              language
              briefTitle
              briefBody
            }
          }
        }
      }

      continuousOptimizationCampaign {
        ...ContinuousOptimizationCampaign
      }
    }
  }
  ${FRAGMENT_CO_CAMPAIGN}
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
};
type Result = BackendProject;

export const queryProjectOptimizationData = async (
  { projectId }: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { projectId },
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
